import { combineReducers } from '@reduxjs/toolkit';

import { createPointsGroupReducer } from 'application/pages/PointsGroupsPage/renderer/slices/createPointsGroup/slice';

import { createAdCampaignReducer } from 'application/pages/AdsPage/slices/createAdCampaign/slice';
import {
  applicationReducer,
  featureFlagsReducer,
  globalPollingReducer,
  acceptanceAdvancedReducer,
} from 'application/store';
import { accountReducer } from './accountSlice';
import { configFlagsReducer } from './configFlagsSlice/configFlagsSlice';
import { uploadsReducer } from './uploadsSlice';

const rootReducer = combineReducers({
  application: applicationReducer,
  acceptanceAdvanced: acceptanceAdvancedReducer,
  account: accountReducer,
  configFlags: configFlagsReducer,
  featureFlags: featureFlagsReducer,
  globalPolling: globalPollingReducer,
  createPointsGroup: createPointsGroupReducer,
  createAdCampaign: createAdCampaignReducer,
  uploads: uploadsReducer,
});

export default rootReducer;

export * from './applicationSlice/selectors';
export * from './applicationSlice/slice';

export * from './acceptanceAdvancedSlice/selectors';
export * from './acceptanceAdvancedSlice/slice';
export * from './acceptanceAdvancedSlice/utils';

export * from './accountSlice/selectors';
export * from './accountSlice/dataSelectors';
export * from './accountSlice/slice';
export * from './accountSlice/thunks';

export * from './configFlagsSlice/configFlagsSlice';
export * from './configFlagsSlice/configFlagThunks';
export * from './configFlagsSlice/configFlagsSelectors';

export * from './featureFlagsSlice/slice';
export * from './featureFlagsSlice/thunks';
export * from './featureFlagsSlice/selectors';

export * from './globalPollingSlice/slice';

export * from './uploadsSlice';
